import {  useState,  } from "react";
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import moment from 'moment';

function TablePaginationActions(props:any) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event:any) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event:any) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event:any) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event:any) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  //count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  //rowsPerPage: PropTypes.number.isRequired,
};

const TableFilesPayRollIncident = ({filePayrollIncident}:any) => {
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(3);
  
  const obtenerURLBase = (url:string) => 
    url.includes('?') ? url.slice(0, url.indexOf('?')) : url;
   
// Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
      page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filePayrollIncident.length) : 0;

    const handleChangePage = (event:any, newPage:any) => {
    setPage(newPage);
    };

    const handleChangeRowsPerPage = (event:any) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };


    const getFileType = (fileName: string) => {
      if (fileName.includes('.pdf')) return '/assets/icons/icon-pdf.svg'
      if (fileName.includes('.jpg')) return '/assets/icons/icon-jpg.svg'
      if (fileName.includes('.jpeg')) return '/assets/icons/icon-jpg.svg'
      if (fileName.includes('.png')) return '/assets/icons/icon-png.svg'
      if (fileName.includes('.mp4')) return '/assets/icons/icon-mp4.svg'
      if (fileName.includes('.zip')) return '/assets/icons/icon-zip.svg'
      if (fileName.includes('.docx')) return '/assets/icons/icon-doc.svg'
      if (fileName.includes('.xlsx')) return '/assets/icons/icon-xlsx.svg'
      return '/assets/icons/icon-pdf.svg'
    }

     return (
      <>
      {filePayrollIncident.length > 0 ?
        <TableContainer>
        <Table sx={{ minWidth: 300 }}>
        <TableHead>
            <TableRow className='pd_contenedorTitulos'>
            <TableCell align="left">Nombre</TableCell>
            <TableCell align="left">Fecha</TableCell>            
            <TableCell align="left"></TableCell>           
          </TableRow>
        </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? filePayrollIncident.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : filePayrollIncident
            ).map((evidence:any) => (
                <TableRow
                key={evidence.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >              
                <TableCell  style={{ width: 400 }} className='TableCellName' align="left">
                  <span className="nameEvidencePayRoll">{evidence.name=== null ?'file':evidence.name }</span>
                </TableCell>
                <TableCell style={{ width: 70 }} align="left">
                  {moment(parseInt(evidence.fecha, 10)).format("DD/MM/YY")}
                </TableCell>
                <TableCell align="center" style={{ width: 70 }} className='fileDown' 
                   onClick={() => window.open(obtenerURLBase(evidence.url), "blank")
                }>
                  <img src={getFileType(obtenerURLBase(evidence.url))} alt="Archivo" className='evidenceTableImage' />
                </TableCell>             
            
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={2} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
               <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'Todas', value: -1 }]}
               colSpan={6}               
               count={filePayrollIncident.length}
               rowsPerPage={rowsPerPage}
               page={page}              
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
               ActionsComponent={TablePaginationActions}
               labelRowsPerPage=''
               sx={{
                 '& .MuiSelect-select':{
                   display: 'none !important'
                 },
                 '& > div.MuiToolbar-root > div.MuiInputBase-root > svg':{
                   display: 'none !important'
                 }
               }}
              /> 
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      :
      <div>No cuenta con archivos</div>
    }
    </>
  )
}

export default TableFilesPayRollIncident
